import { useState } from 'react'
import Box from '@mui/material/Box'
import CSVReader from 'react-csv-reader'
import { reExportedColors, FeedbackSnackbar } from '../1elements'
import FormTextField from './FormTextField'

const FileUploader = ({ className, setDataArrayFromCsv, selectedFileName, setSelectedFileName, templateHeaderList }) => {
  const [snackbar, setSnackbar] = useState({
    severity: 'fail',
    isOpen: false,
    message: ''
  })

  const overSizeErrorMessage = 'The file size has exceededthan 40 data entries. Split the file into parts to reduce the file size.'
  const emptyFileErrorMessage = 'Please fill out the template correctly.'
  const headerErrorMessage = 'Please ensure that no columns are added/deleted, or moved within the file.'
  const fileFormatErrorMessage = 'The file format is not csv. Upload csv file only.'

  const isHeaderModified = (acceptedFiles, headers) => {
    const keyArray = Object.keys(acceptedFiles[0])
    if (keyArray.length !== headers.length) return true

    for (let i = 0; i < keyArray.length; i++) {
      const lastHeaderKey = `${keyArray[i]}\n`
      if (!headers.includes(keyArray[i]) && !headers.includes(lastHeaderKey)) {
        return true
      }
    }
    return false
  }

  const handleUpload = (acceptedFiles, fileData) => {
    const fileName = fileData.name

    if (acceptedFiles.length > 40 || fileData.size >= 20 * 1000) {
      setSnackbar({ ...snackbar, isOpen: true, message: overSizeErrorMessage })
    } else if (!acceptedFiles.length) {
      setSnackbar({ ...snackbar, isOpen: true, message: emptyFileErrorMessage })
    } else if (isHeaderModified(acceptedFiles, templateHeaderList)) {
      setSnackbar({ ...snackbar, isOpen: true, message: headerErrorMessage })
    } else if (!fileName.includes('.csv')) {
      setSnackbar({ ...snackbar, isOpen: true, message: fileFormatErrorMessage })
    } else {
      setDataArrayFromCsv(acceptedFiles)
      setSelectedFileName(fileName)
    }
  }

  const parseOptions = {
    accept: '.csv',
    header: true,
    skipEmptyLines: true,
    quotes: true,
    transformHeader: header => header.toLowerCase().replace(/\W/g, '_')
  }

  return (
    <>
      <Box
        className={className}
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          width: '500px'
        }}
      >
        <FormTextField
          value={selectedFileName}
          disabled
          sx={{
            flexGrow: 1,
            marginRight: '20px',
            '& .MuiFormHelperText-root': { display: 'none' },
            '& .MuiInputBase-root': { pointerEvents: 'none' },
            '& .MuiInputBase-input': { color: reExportedColors.TEXT }
          }}
        />

        <Box
          component='label'
          sx={{
            margin: 0,
            '& .csv-reader-root': { display: 'none' },
            '& span': {
              backgroundColor: 'rgb(95, 95, 95)',
              borderRadius: '4px',
              color: 'rgb(255, 255, 255)',
              display: 'inline-box',
              height: '35px',
              padding: '6px 16px',
              transition: 'background .5s',
              '&:hover': {
                background: '#999',
                cursor: 'pointer'
              }
            }
          }}
        >
          <CSVReader
            cssClass='csv-reader-root'
            onFileLoaded={handleUpload}
            parserOptions={parseOptions}
          />
          <span>Select File</span>
        </Box>
      </Box>
      <FeedbackSnackbar snackbar={snackbar} setSnackbar={setSnackbar} />
    </>
  )
}

export default FileUploader
